const GlobalFuncs = {
  install (Vue, options) {
    Vue.prototype.GMessage = function (funcName, content, btnName, targetPath) {
      this.$Message.destroy()
      this.$root.$emit('setAppMask', event, true)
      this.$Message[funcName]({
        closable: true,
        duration: 0,
        render: h => {
          return h('div', { class: 'msg_wrap' }, [
            h('p', { class: 'msg_content' }, content),
            h('Button', {
              class: 'modal_btn',
              attrs: { type: 'primary' },
              on: {
                click: event => {
                  event.stopPropagation()
                  event.preventDefault()
                  this.$root.$emit('setAppMask', event, false)
                  this.$Message.destroy()
                  setTimeout(() => {
                    this.$router.push(targetPath)
                  }, 400)
                }
              }
            }, btnName)
          ])
        }
      })
    }
    Vue.prototype.GJFNotice = function (callback) {
      let u = this._h.storage.local.get('uinfo')
      let c = this._h.storage.local.get('ust')
      if (!Vue._.isEmpty(u) && c && c.integralSwitch === 1) {
        // eslint-disable-next-line
        callback && callback(true)
      } else {
        // eslint-disable-next-line
        callback && callback(false)
      }
    }
    Vue.prototype.GConfirm = function (content, callback) {
      this.$Message.destroy()
      this.$root.$emit('setAppMask', event, true)
      this.$Message.warning({
        closable: true,
        duration: 0,
        render: h => {
          return h('div', { class: ['msg_wrap', 'msg_confirm'] }, [
            h('p', { class: 'msg_content' }, content),
            h('div', { class: 'msg_footer' }, [
              h('Button', {
                class: 'btn_cancel',
                attrs: { type: 'ghost' },
                on: {
                  click: event => {
                    event.stopPropagation()
                    event.preventDefault()
                    // eslint-disable-next-line
                    callback && callback(false)
                    this.$root.$emit('setAppMask', event, false)
                    this.$Message.destroy()
                  }
                }
              }, '\u53d6\u6d88'),
              h('Button', {
                class: 'btn_confirm',
                attrs: { type: 'primary' },
                on: {
                  click: event => {
                    event.stopPropagation()
                    event.preventDefault()
                    this.$root.$emit('setAppMask', event, false)
                    this.$Message.destroy()
                    setTimeout(() => {
                      // eslint-disable-next-line
                      callback && callback(true)
                    }, 300)
                  }
                }
              }, '\u786e\u5b9a')
            ])
          ])
        }
      })
    }
  }
}

export default GlobalFuncs



// WEBPACK FOOTER //
// ./src/assets/js/funcs.js